// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightFinanceiroInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de GET /migration/financeiro/preflight?zoho_id_unidade=...
 * (controllers/migration/financeiro.php::preflight).
 *
 * A franquia e OBRIGATORIA pelo mesmo limite da E3: o export global de
 * Plano_de_Contas (18737 linhas) estoura o limite de execucao do Creator
 * (HTTP 500, code 9430 — medido em 2026-08-20).
 */
import { registerContract } from './validate'

export interface Migration_PreflightFinanceiroInput {
zoho_id_unidade?: string
data_ini?: string
data_fim?: string
ids?: string
}

registerContract('Migration_PreflightFinanceiroInput', {
  zoho_id_unidade: { type: 'string',  required: false },
  data_ini:        { type: 'string',  required: false },
  data_fim:        { type: 'string',  required: false },
  ids:             { type: 'string',  required: false },
})
